// File: cambioPassword.ts
import Component from "~/components/Component";
import Page from "../pages/Page";
import {getApi, handleError, logout, userInfo} from "~/auth";
import * as validation from "~/utils/validation";
import UI from "~/ui";
import { t } from "~/hooks/useI18n";
import $ from "jquery";
import {getParameterValue, gotoDefault, navigateTo} from "~/utils";
import {validatePassword, comparePassword} from "~/utils/password";

let eventsRegistered = false;

class CambioPasswordComponent extends Component {

    private theForm: HTMLFormElement = document.getElementById("frmCambioPassword") as HTMLFormElement;
    private isSubmitting = false; // Flag per tracciare lo stato
    private onSuccessCallback: (() => void) | null = null;

    
    constructor(containerId: string) {
        super(containerId);
    }

    public setOnSuccessCallback(callback: () => void): void {
        this.onSuccessCallback = callback;
    }

    public async activate(): Promise<void> {
        const that = this; // Cattura il valore di 'this'
        
        const btnCambioPassword = $(this.domElement).find("#btnCambioPassword");

        if (btnCambioPassword.length === 0) {
            console.error("Pulsante cambio password non trovato");
            return;
        }

        if (eventsRegistered) {
            return Promise.resolve();
        }
        
        that.addValidation();
        
        // Aggiungi listener al pulsante
        btnCambioPassword.on("click", (event) => {
            event.preventDefault();

            if (that.isSubmitting) {
                console.warn("Invio già in corso, ignoro il click");
                return false;
            }
            that.handleFormSubmit();
        });

        eventsRegistered = true;
        return Promise.resolve();
    }

    //TODO funzione addValidation modificata da Roberto

    private addValidation() {
        const form = this.theForm;

        // Gestisce la classe mb-4 sul div form-floating di errore
        function updateInputGroupClass(inputId: string, isValid: boolean) {
            const $group = $(`#error_${inputId}`);
            if ($group.length) {
                if (isValid) {
                    $group.removeClass("mb-4");
                } else {
                    $group.addClass("mb-4");
                }
            }
        }

        // Validatore campo obbligatorio
        const requiredValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const value = $(inputElement).val() as string;
            const isValid = value.trim().length > 0;
            updateInputGroupClass(inputElement.id, isValid);
            return {
                ok: isValid,
                error: isValid ? "" : t("messages.requiredField"),
                class: isValid ? "" : "mb-4"
            };
        };

        // Validatore password
        const passwordValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const password = $(inputElement).val() as string;
            const isValid = validatePassword(password);
            updateInputGroupClass(inputElement.id, isValid.ok);
            return {
                ok: isValid.ok,
                error: isValid.ok ? "" : t("messages.invalidFormat"),
                class: isValid.ok ? "" : "mb-4"
            };
        };

        // Validatore confronto password
        const compareValidator = (inputElement: HTMLInputElement, compareElement: HTMLInputElement): validation.ValidationResult => {
            const confermaPassword = $(inputElement).val() as string;
            const password = $(compareElement).val() as string;
            let isValid = false;
            let error = "";
            if (!confermaPassword || confermaPassword.trim().length === 0) {
                error = t("messages.requiredField");
            } else {
                const result = comparePassword(password, confermaPassword);
                isValid = result.ok;
                error = isValid ? "" : t("messages.passwordsDoNotMatch");
            }
            updateInputGroupClass(inputElement.id, isValid);
            return {
                ok: isValid,
                error: error,
                class: isValid ? "" : "mb-4"
            };
        };

        // Validazione live su input
        form.addEventListener("input", (event) => {
            form.classList.remove("was-validated");
            const input = event.target as HTMLInputElement;
            if (input && input.id) {
                switch (input.id) {
                    case "OldPassword":
                        validation.validate("OldPassword", requiredValidator);
                        break;
                    case "NewPassword":
                        validation.validate("NewPassword", passwordValidator);
                        validation.validate("ConfirmPassword", (el) =>
                            compareValidator(el, document.getElementById("NewPassword") as HTMLInputElement)
                        );
                        break;
                    case "ConfirmPassword":
                        validation.validate("ConfirmPassword", (el) =>
                            compareValidator(el, document.getElementById("NewPassword") as HTMLInputElement)
                        );
                        break;
                }
            }
        });

        // Applica i validatori ai campi
        validation.setValidatorOnInput("OldPassword", requiredValidator);
        validation.setValidatorOnInput("NewPassword", passwordValidator);
        validation.setValidatorOnInput("ConfirmPassword", (inputElement) =>
            compareValidator(inputElement, document.getElementById("NewPassword") as HTMLInputElement)
        );

        // Validazione al submit
        this.onSubmitValidator = async () => {
            validation.validate("OldPassword", requiredValidator);
            validation.validate("NewPassword", passwordValidator);
            validation.validate("ConfirmPassword", (inputElement) =>
                compareValidator(inputElement, document.getElementById("NewPassword") as HTMLInputElement)
            );
        };
    }
       

    private onSubmitValidator: () => void = async () => {
    }

    private async handleFormSubmit(): Promise<void> {
        // Validazione del form
        this.onSubmitValidator();
        if (!this.theForm.checkValidity()) {
            this.theForm.classList.add('was-validated');
            return;
        }

        // ✅ Imposta la flag e disabilita il pulsante
        this.isSubmitting = true;
        const $btnSubmit = $("#btnCambioPassword");
        const originalText = $btnSubmit.html();

        // ✅ Mostra feedback visivo
        $btnSubmit.prop("disabled", true)
            .html(`<span class="spinner-border spinner-border-sm me-2"></span>${t("messages.savingInProgress")}`);




        const oldPassword = $(this.domElement).find("#OldPassword").val() as string;
        const newPassword = $(this.domElement).find("#NewPassword").val() as string;
        let _ = Page.current.spinner.spin();
        try {

            const auth = getApi();
            const userinfo = auth.getCached("userInfo");

            if (userinfo && userinfo.isAuthenticated && userinfo.email) {
                let result = await getApi().changePassword(userinfo.email, oldPassword, newPassword);
                let _ = await userInfo(true);
                if (result) {
                    UI.confirmOneButton("", t("messages.passwordChangedSuccess"));
                } else {
                    UI.confirmOneButton("", t("messages.errorChangingPassword"));
                }
            }
            
            // Richiama la callback di successo se definita
            if (this.onSuccessCallback) {
                this.onSuccessCallback();
            }

            // Se non siamo dentro il profilo, torna alla pagina di default
            if (!document.querySelector("#profiloTab")) {
                const returnUrlParam = getParameterValue("returnUrl");
                if (returnUrlParam && returnUrlParam.length > 0) {
                    _ = navigateTo(decodeURIComponent(returnUrlParam));
                } else 
                    _ = gotoDefault();
            }else{
                // Se siamo dentro il profilo, ricarica la pagina
                const formElement = $(this.domElement).get(0) as HTMLFormElement;
                if (formElement) {
                    formElement.reset();
                    formElement.classList.remove('was-validated');

                    // Assicurati di rimuovere eventuali messaggi di errore personalizzati
                    $(this.domElement).find(".invalid-feedback").hide();
                    $(this.domElement).find(".is-invalid").removeClass("is-invalid");

                }
            }

        } catch (error) {
            _ = UI.message(handleError(error));
        } finally {
            Page.current.spinner.stop();
            this.isSubmitting = false; // ✅ Reset della flag
            $btnSubmit.html(originalText).removeAttr("disabled");
        }
    }

}

export default CambioPasswordComponent;